var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14985 9.73901L6.12837 10.6899V0.850609C6.12837 0.380831 6.51675 0 7.00337 0C7.48662 0 7.87837 0.380706 7.87837 0.850609V10.6899L8.85689 9.73901C9.20005 9.40552 9.75287 9.40205 10.097 9.73644C10.4387 10.0685 10.4367 10.6089 10.0943 10.9415L7.62473 13.3415C7.45167 13.5097 7.22795 13.5922 7.00402 13.5921C6.77978 13.5936 6.55626 13.5108 6.38465 13.3441C6.38289 13.3424 3.91242 10.9415 3.91242 10.9415C3.56925 10.6081 3.56569 10.0708 3.90978 9.73644C4.25149 9.40437 4.80752 9.40633 5.14985 9.73901ZM12.25 15.2995V12.7484C12.25 12.2787 12.6418 11.898 13.125 11.898C13.6082 11.898 14 12.2787 14 12.7484V15.2995C14 16.2372 13.2161 17 12.2538 17H1.74617C0.780314 17 0 16.2406 0 15.2995V12.7484C0 12.2787 0.391751 11.898 0.875 11.898C1.35825 11.898 1.75 12.2787 1.75 12.7484L1.74617 15.2993L12.25 15.2995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e523a6c568e6137ad26a277839188562.svg";
export { ForwardRef as ReactComponent };